import clsx from "clsx";

export type StatusChipVariant =
  | "due"
  | "overdue"
  | "paid"
  | "refunded"
  | "partially_paid"
  | "failed"
  | "open"
  | "draft"
  | "sent"
  | "uncollectible"
  | "void"
  | "partially_refunded"
  | "scheduled"
  | "pending"
  | "cart"
  | "default";

interface StatusChipProps {
  label: string;
  variant?: StatusChipVariant;
}

const VARIANT_CLASSES: Record<StatusChipVariant, string> = {
  due:                "bg-yellow-100 text-yellow-800 border border-yellow-300",
  overdue:            "bg-red-100 text-red-800 border border-red-300",
  paid:               "bg-green-600 text-white border border-green-600",
  refunded:           "bg-blue-100 text-blue-800 border border-blue-300",
  partially_paid:     "bg-yellow-50 text-yellow-700 border border-yellow-200",
  failed:             "bg-destructive text-destructive-foreground border border-destructive",
  open:               "bg-background text-foreground border border-border",
  draft:              "bg-muted text-muted-foreground border border-muted",
  sent:               "bg-blue-50 text-blue-700 border border-blue-200",
  uncollectible:      "bg-red-50 text-red-700 border border-red-200",
  void:               "bg-muted text-muted-foreground border border-muted",
  partially_refunded: "bg-blue-50 text-blue-600 border border-blue-200",
  scheduled:          "bg-background text-foreground border border-border",
  pending:            "bg-primary text-white border border-primary",
  cart:               "bg-muted text-muted-foreground border border-muted",
  default:            "bg-muted text-muted-foreground border border-muted",
};

export const StatusChip = ({ label, variant = "default" }: StatusChipProps) => {
  return (
    <span
      className={clsx(
        "self-start px-2 py-0.5 rounded-md text-xs font-semibold leading-normal",
        VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.default
      )}
    >
      {label}
    </span>
  );
};